module.exports = __webpack_public_path__ + "static/media/avatar_button.91aa78f8.svg";